import { render } from "./StaffList.vue?vue&type=template&id=9a5e5f14&scoped=true"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"

import "./StaffList.vue?vue&type=style&index=0&id=9a5e5f14&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5e5f14"]])

export default __exports__